<template lang="pug">
app-modal(v-model="visible" :title="title" :width="1200" @ok="handleSubmit" @cancel="hide")
  div.point-select
    div.head-tools.flex
      app-search(
        v-model="filters"
        :fields="filterFieleds"
        keywordPlaceholder="产品代码/名称"
      )
      a-button.ml2(@click="$refs.table.reload()") 刷新
    div.content.mt2(style="overflow: hidden;" v-if="visible")
      app-custom-table(
        ref="table"
        api="/prj/products/page"
        :params="params"
        :tableColumns="tableColumns"
        :defaultSelections="defaultSelections"
        :dataFormater="dataFormater"
      )
        //- rowKey="productId"
    //- div.footer.flex.justify-between
      div.footer-left
        //- Left
      div.footer-right
        a-button.ml2(type="default" @click="cancel") 取消
        a-button.ml2(type="primary" @click="handleSubmit") 确定

    
</template>

<script>
import { GETTER_PROJECT } from '@store/account';
import { mapGetters } from 'vuex';
export default {
  name: 'ProductSelect',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: [Array, Object],
    target: Object,
  },
  data() {
    return {
      visible: false,
      title: '选择产品',
      tableColumns: [],
      // columns: ['name', 'type', 'dept', 'enabled'],
      // 选中
      defaultSelections: [],

      // 筛选
      filters: { enabled: true, availableInventoryIsZero: 'false' },
      filterFieleds: [],
      dataFormater(data) {
        return data.map((item) => {
          return {
            id: this.$getUid(),
            productId: item.productId || item.id,
            productComments: item.productComments || '',
            quantity: item.quantity || item.availableQuantity || 1,
            productDTO: item.productDTO || item,
          };
        });
      },
    };
  },
  computed: {
    ...mapGetters({
      project: GETTER_PROJECT,
    }),
    params() {
      return {
        ...this.filters,
        vendorId: this.target?.vendorId,
        projectId: this.project.id,
        hasInventory: true,
      };
    },
  },
  watch: {
    value: 'handleValueChange',
  },
  created() {
    this.initTableColumns();
    this.initFilters();
  },
  methods: {
    // 根据 value 改变选中项
    handleValueChange() {
      this.defaultSelections = [...this.value] || [];
      // this.$refs.table.selections = this.value || [];
    },
    show() {
      this.handleValueChange();
      this.visible = true;
    },
    hide() {
      this.visible = false;
    },
    cancel() {
      this.$emit('update:visible', false);
    },
    handleSubmit() {
      const selectRows = this.$refs.table.selections || [];
      this.$emit('change', [...selectRows]);
      // this.$refs.table.selectedRowKeys = [];
      this.hide();
    },

    // 初始化表格 列
    initTableColumns() {
      this.tableColumns = [
        {
          uid: 'code',
          dataIndex: 'code',
          title: '产品代码',
          width: '150px',
          // sorter: true,
          render(h, v, r) {
            return r.productDTO.code || '--';
          },
        },
        {
          uid: 'name',
          dataIndex: 'name',
          title: '产品名称',
          width: '200px',
          render(h, v, r) {
            return r.productDTO.name || '--';
          },
        },
        {
          uid: 'categoryName',
          dataIndex: 'categoryName',
          title: '产品类别',
          width: '100px',
          render(h, v, r) {
            return r.productDTO.categoryName || '--';
          },
        },
        {
          uid: 'brandName',
          dataIndex: 'brandName',
          title: '产品品牌',
          width: '100px',
          render(h, v, r) {
            return r.productDTO.brandName || '--';
          },
        },
        {
          uid: 'parts',
          dataIndex: 'parts',
          title: '分件数',
          width: '80px',
          customClass: ['center'],
          render(h, v, r) {
            return r.productDTO.parts || '--';
          },
        },
        {
          uid: 'inventoryQuantity',
          dataIndex: 'inventoryQuantity',
          title: '库存',
          width: '80px',
          customClass: ['center'],
          render(h, v, r) {
            return r.productDTO.inventoryQuantity;
          },
        },
        {
          uid: 'customerOrderCode',
          dataIndex: 'customerOrderCode',
          title: '客户订单号',
          width: '150px',
          render(h, v, r) {
            return r.productDTO.customerOrderCode || '--';
          },
        },
        {
          uid: 'inventoryComments',
          dataIndex: 'inventoryComments',
          title: '备注',
          width: 'auto',
          flex: '1',
          render(h, v, r) {
            return r.productDTO.inventoryComments || '--';
          },
        },
        // {
        //   uid: 'enabled',
        //   dataIndex: 'enabled',
        //   title: '状态',
        //   width: '60px',
        //   render(h, v, r) {
        //     return (
        //       <app-enabled-display
        //         enabled={r.productDTO.enabled}
        //         trueLabel="上线"
        //         falseLabel="下线"
        //       />
        //     );
        //   },
        // },
        {
          uid: 'warehouseId',
          dataIndex: 'warehouseId',
          title: '仓库/分区',
          width: 'auto',
          flex: '1',
          render(h, v, r) {
            return (
              (r.productDTO.warehouseName ? r.productDTO.warehouseName : '--') +
              '/' +
              (r.productDTO.warehousePartitionName
                ? r.productDTO.warehousePartitionName
                : '--')
            );
          },
        },
      ];
    },
    // 初始化筛选条件
    initFilters() {
      this.filterFieleds = [
        {
          name: 'searchInventory',
          component: 'a-input-search',
          width: '150px',
          placeholder: '客户名称/订单号',
        },
        {
          name: 'categoryId',
          component: 'app-tree-select',
          width: '150px',
          placeholder: '请选择产品类别',
          api: '/prj/categories/all-graph',
          params: { projectId: this.project.id },
          allowClear: true,
          treeDefaultExpandAll: true,
        },
        {
          name: 'brandId',
          component: 'app-remote-select',
          width: '150px',
          placeholder: '品牌',
          api: '/prj/brands/list',
          params: { projectId: this.project.id },
          showSearch: true,
        },
        {
          name: 'availableInventoryIsZero',
          component: 'app-remote-select',
          width: '150px',
          placeholder: '有无库存',
          options: [
            { code: 'false', name: '有库存' },
            { code: 'true', name: '不限制' },
          ],
          field: { name: 'code', label: 'name' },
        },
      ];
    },
  },
};
</script>

<style lang="less" scoped>
.point-select {
  width: 100%;
  // height: 400px;
}
</style>
